import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
import { EmoteRequestInfo } from './types';

export const init = createAction(`${actionTypePrefix}/INIT`, () => ({}));

export const initDoneAlready = createAction(
  `${actionTypePrefix}/INIT_DONE_ALREADY`,
  () => ({})
);

export const initDone = createAction(
  `${actionTypePrefix}/INIT_DONE`,
  result => ({
    result,
  })
);

export const switchStream = createAction(
  `${actionTypePrefix}/SWITCH_STREAM`,
  (payload: EmoteRequestInfo) => payload
);

export const initStreamDone = createAction(
  `${actionTypePrefix}/INIT_STREAM_DONE`,
  (streamType, result) => ({
    streamType,
    result,
  })
);

export const streamLoadMore = createAction(
  `${actionTypePrefix}/STREAM_LOAD_MORE`,
  () => ({})
);

export const streamLoadDone = createAction(
  `${actionTypePrefix}/STREAM_LOAD_DONE`,
  (streamType, result) => ({
    streamType,
    result,
  })
);

export const storeSearchData = createAction(
  `${actionTypePrefix}.STORE_SEARCH_DATA`,
  (searchType, searchQuery) => ({ searchType, searchQuery })
);
